import { CompanyBillingsConfig } from '@/types/company'
import { api } from '@/utils/api'
import { apiCompanyBillingsConfig } from '@/utils/api/url'
import { useQuery } from '@tanstack/react-query'

export const QUERY_KEY_COMPANY_BILLING_CONFIG =
  'QUERY_KEY_COMPANY_BILLING_CONFIG'

export const useGetCompanyBillingConfig = () => {
  const res = useQuery({
    queryKey: [QUERY_KEY_COMPANY_BILLING_CONFIG],
    queryFn: () =>
      api
        .get(apiCompanyBillingsConfig)
        .then(({ data }) => data as CompanyBillingsConfig),
    staleTime: 60 * (60 * 4000), //4 hours
  })
  return res
}
